/**
 * Created by Tuyen Tran on 11/02/2021.
 */

export const SCALE_VALUE_VALIDATOR: RegExp = /^([1-9]|10)$/; // 1 to 10
export const STACK_VALUE_VALIDATOR: RegExp = /^([1|2])$/; // 1|2
export const SIZE_VALUE_VALIDATOR: RegExp = /^(lg|sm|xs)$/;
export const FLIP_VALUE_VALIDATOR: RegExp = /['horizontal'|'vertical'|'both']/;
export const PULL_VALUE_VALIDATOR: RegExp = /['right'|'left']/;
export const ANIMATION_VALUE_VALIDATOR: RegExp = /['spin'|'pulse']/;
export const ROTATE_VALUE_VALIDATOR: RegExp = /[90|180|270]/;
